module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "img-back pull-left",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["点名"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right icon-setup text-hide",
    on: {
      "click": function($event) {
        _vm.popupVisebleRollcallList = true
      }
    }
  }, ["发起点名"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadBottom),
      expression: "loadBottom"
    }],
    staticClass: "main-page",
    attrs: {
      "infinite-scroll-disabled": "isGetting",
      "infinite-scroll-distance": "150"
    }
  }, [_vm._l((_vm.rollcallList), function(item) {
    return _vm._h('div', {
      staticClass: "rollcall"
    }, [_vm._h('p', {
      staticClass: "margin-15"
    }, [_vm._s(_vm.getAliasDate(item.time))]), " ", _vm._h('ul', {
      staticClass: "list-group-item"
    }, [_vm._l((item.list), function(callInfo) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", (callInfo.typeId == 0) ? _vm._h('a', {
        staticClass: "padding-15 clearfix block",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.goRollcallDetail(callInfo)
          }
        }
      }, [_vm._h('span', {
        staticClass: "pull-right text-right"
      }, [(callInfo.callStudentNum == 0) ? _vm._h('span', {
        staticClass: "rollinfo succ"
      }, ["全部已点"]) : _vm._h('span', {
        staticClass: "rollinfo warning"
      }, [_vm._s(callInfo.callStudentNum) + "人未点"]), " "]), " ", _vm._h('span', {
        staticClass: "pull-left"
      }, [_vm._h('span', {
        staticClass: "block"
      }, [_vm._h('span', {
        staticClass: "font-16"
      }, [_vm._s(callInfo.msg)])]), " ", _vm._h('span', {
        staticClass: "block gray"
      }, [_vm._s(callInfo.teacherName)]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s(callInfo.callBeginTime)])])]) : _vm._e(), " ", (callInfo.typeId == 1) ? _vm._h('a', {
        staticClass: "padding-15 clearfix block",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.goRollcallDetail(callInfo)
          }
        }
      }, [_vm._h('span', {
        staticClass: "pull-left"
      }, [_vm._h('span', {
        staticClass: "block"
      }, [_vm._h('span', {
        staticClass: "font-16"
      }, ["家长接回"])]), " ", _vm._h('span', {
        staticClass: "block gray font-12"
      }, ["记录每天家长到园点接回孩子情况，家长确认接回孩子后所发生的安全责任与园点无关"])]), " ", _vm._h('span', {
        staticClass: "pull-right text-right"
      }, [(callInfo.callStudentNum == 0) ? _vm._h('span', {
        staticClass: "rollinfo succ"
      }, ["全部已点"]) : _vm._h('span', {
        staticClass: "rollinfo warning"
      }, [_vm._s(callInfo.callStudentNum) + "人未点"]), " "])]) : _vm._e()])
    })])])
  })])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupVisebleRollcallList),
      expression: "popupVisebleRollcallList"
    }],
    attrs: {
      "position": "bottom"
    },
    domProps: {
      "value": (_vm.popupVisebleRollcallList)
    },
    on: {
      "input": function($event) {
        _vm.popupVisebleRollcallList = $event
      }
    }
  }, [_vm._h('div', {
    staticClass: "roll-setup"
  }, [_vm._h('span', {
    staticClass: "block text-center margin-15"
  }, ["选择名单"]), " ", _vm._h('ul', {
    staticClass: "clearfix padding-15"
  }, [_vm._h('li', {
    staticClass: "col-xs-4"
  }, [_vm._h('a', {
    staticClass: "button-pill-circle block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.insertStudentCall(101)
      }
    }
  }, ["中午接"])]), " ", _vm._h('li', {
    staticClass: "col-xs-4"
  }, [_vm._h('a', {
    staticClass: "button-pill-circle block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.insertStudentCall(102)
      }
    }
  }, ["中午送"])]), " ", _vm._h('li', {
    staticClass: "col-xs-4"
  }, [_vm._h('a', {
    staticClass: "button-pill-circle block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.insertStudentCall(103)
      }
    }
  }, ["傍晚接"])]), " ", " ", _vm._h('li', {
    staticClass: "col-xs-6"
  }, [_vm._h('router-link', {
    staticClass: "button-pill-circle block",
    attrs: {
      "to": {
        'path': '/rollcall/custom'
      }
    }
  }, ["自定义名单"])]), " ", _vm._h('li', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "block text-center font-12 gray padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.isHideCreateRollcallHelp = !_vm.isHideCreateRollcallHelp
      }
    }
  }, ["不明白？点这里"])])]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('p', {
    staticClass: "gray margin-15 font-12"
  }, ["点名功能可以多个老师同时协作点名，孩子点名情况及时反馈给关联家长。", _vm._h('br'), "点名记录只保存一个月，到期自动清空哦！"]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideCreateRollcallHelp),
      expression: "!isHideCreateRollcallHelp"
    }]
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('p', {
    staticClass: "padding-15"
  }, [_vm._h('strong', ["中午接、中午送："]), _vm._h('br'), "\n中午接和中午送包含午托，午晚托，中托，零托，长托，全托。", _vm._h('br'), _vm._h('br'), " ", _vm._h('strong', ["傍晚接："]), _vm._h('br'), "\n包含晚托，午晚托，中托，傍晚托，零托，全托，长托。", _vm._h('br'), " ", _vm._h('br'), " ", _vm._h('strong', ["自定义："]), _vm._h('br'), "\n自己选择要点名的名单\n        "])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('span', {
    staticClass: "group-txt text-center",
    on: {
      "click": function($event) {
        _vm.popupVisebleRollcallList = false
      }
    }
  }, ["取消"])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-28771042!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/rollcall/rollcallList.vue
// module id = 189
// module chunks = 1